import React from 'react';
import './Footer.css';
import { FaLinkedin, FaGithub, FaGlobe, FaHeart } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>SyncWithVikash</h3>
            <p>
              Flutter & iOS developer building production-ready mobile applications 
              for healthcare, education, enterprise, and commerce domains.
            </p>
            <div className="footer-social">
              <a 
                href="https://www.linkedin.com/in/vikash-kumar-sharma-35482a104" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="footer-social-icon"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a 
                href="http://syncwithvikash.me/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="footer-social-icon"
                aria-label="Portfolio"
              >
                <FaGlobe />
              </a>
              <a 
                href="https://github.com/vikash" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="footer-social-icon"
                aria-label="GitHub"
              >
                <FaGithub />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Flutter Development</a></li>
              <li><a href="#services">iOS Development</a></li>
              <li><a href="#services">Backend APIs</a></li>
              <li><a href="#services">UI/UX Design</a></li>
              <li><a href="#services">App Publishing</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul className="contact-list">
              <li>📧 kumarvikash010203@gmail.com</li>
              <li>📱 +91-9639631382</li>
              <li>📍 Gautam Buddha Nagar, UP</li>
              <li>🕒 Available for Freelance Projects</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} SyncWithVikash. All rights reserved.</p>
          <p className="made-with">
            Made with <FaHeart className="heart-icon" /> by Vikash Kumar Sharma
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
